import SvgIcon from './svg-icon';
import {Icon} from './icon';

export default SvgIcon;
export {Icon};
